// post metaData Extractor
import { createSelector } from "reselect";
import { AppState } from "../../rootReducer";

const postMetaDataExtractorPending = (state: AppState) => state.metaDataPostExtractorReducer.pending;
const postMetaDataExtractor = (state: AppState) => state.metaDataPostExtractorReducer.extMetaDataStatus;
const postMetaDataExtractorError = (state: AppState) => state.metaDataPostExtractorReducer.error;

export const postDataPendingSelector = createSelector(postMetaDataExtractorPending, (pending) => pending);
export const postDataSelector = createSelector(postMetaDataExtractor, (extractor) => extractor);
export const postDataErrorSelector = createSelector(postMetaDataExtractorError, (error) => error);

//Put metaData Extractor
const putMetaDataExtractorPending = (state: AppState) => state.metaDataPutExtractorReducer.pending;
const putMetaDataExtractor = (state: AppState) => state.metaDataPutExtractorReducer.extMetaDataStatus;
const putMetaDataExtractorError = (state: AppState) => state.metaDataPutExtractorReducer.error;

export const putMetadataPendingSelector = createSelector(putMetaDataExtractorPending, (pending) => pending);
export const putDataSelector = createSelector(putMetaDataExtractor, (extractor) => extractor);
export const putDataErrorSelector = createSelector(putMetaDataExtractorError, (error) => error);


//Get Extractor Table MetaData
const getTableMetaDataExtractorPending = (state: AppState) => state.extMetaDataTableReducer.pending;
const getTableMetaDataExtractor = (state: AppState) => state.extMetaDataTableReducer.tableMetadata;
const getTableMetaDataExtractorError = (state: AppState) => state.extMetaDataTableReducer.error;

export const getExtTableMetaDataPendingSelector = createSelector(getTableMetaDataExtractorPending, (pending) => pending);
export const getExtTableMetaDataSelector = createSelector(getTableMetaDataExtractor, (tableMetaData) => tableMetaData);
export const getExtTableMetaDataErrorSelector = createSelector(getTableMetaDataExtractorError, (error) => error);

//Get Foundry Table MetaData
const getFoundryMetaDatarPending = (state: AppState) => state.foundryMetaDataReducer.pending;
const getFoundryMetaData = (state: AppState) => state.foundryMetaDataReducer.foundryMetadata;
const getFoundryMetaDataError = (state: AppState) => state.foundryMetaDataReducer.error;

export const getFoundryMetaDataPendingSelector = createSelector(getFoundryMetaDatarPending, (pending) => pending);
export const getFoundryMetaDataSelector = createSelector(getFoundryMetaData, (foundryMetaData) => foundryMetaData);
export const getFoundryMetaDataErrorSelector = createSelector(getFoundryMetaDataError, (error) => error);
